import { Box } from "@mui/material";
import React from "react";
import TabHeading from "../../../common/tabs/TabHeading";
import ActiveTrackingList from "./ActiveTrackingList";

function TrackingList() {
  return (
    <Box
      sx={{
        width: "calc(100% - 40px)",
        height: "calc(100% - 40px)",
        display: "flex",
        flexDirection: "column",
        margin: "20px",
      }}
    >
      <TabHeading heading="Active" /> {/* In future replace this with tab */}
      <Box
        sx={{
          width: "100%",
          flexGrow: 1,
          mt: "20px",
          overflowY: "auto",
        }}
      >
        {/* In future based on tab id change view inside this */}
        <ActiveTrackingList />
      </Box>
    </Box>
  );
}

export default TrackingList;
